// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wnb","msrp":"e_Xnb","save":"e_Ynb","discount":"e_Znb","price":"e__nb"};